/*
 * Copyright (c) Nexign, JSC, 2019-2025.
 */
/**
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @author Pavel Antonov
 * @author Ilya Babanov
 * @author Evgeniy Naumov
 * @author Ilya Baranchikov
 * @author Viacheslav Smalenski
 * @author Nikolay Sviridov
 * @version 1.38.0
 * @since 1.0.0
 */

import { ETextBlockStatus } from '@components/common/TextBlockStatus/textBlockStatusTypes';
import initTranslationUserTypes from '@modules/internationalization/constants/common/userTypes';

import { ICorporateTranslation } from '../types';

const initTranslationCorporate: ICorporateTranslation = {
    corporateTable: {
        availability: {
            [ETextBlockStatus.ERROR]: '',
            [ETextBlockStatus.OK]: '',
            [ETextBlockStatus.PARTIALLY]: '',
            [ETextBlockStatus.WARNING]: '',
            [ETextBlockStatus.CHANGE]: '',
        },
        actionConflictsTitle: {
            error: '',
            warning: '',
            numberCodeCustomErrors: {
                willBeExcluded: '',
                errors: {
                    'subscriber-has-subscription-group': '',
                    'group-of-subscribers-is-connected-to-tariff': '',
                },
            },
        },
        noValue: '',
        serviceAccess: {
            loginPrefix: '',
        },
        statuses: {
            failed: '',
            handles: '',
            partiallyProcessed: '',
            pendingProcessing: '',
            ready: '',
        },
        total: '',
    },
    corporateTableFooter: {
        types: {},
    },
    createInquiry: {
        attachFile: '',
        client: '',
        close: '',
        create: '',
        createTitle: '',
        description: '',
        descriptionPlaceholder: '',
        email: '',
        emailPlaceholder: '',
        emailTooltip: '',
        fileAttachedWithErrors: '',
        incorrectEmail: '',
        incorrectPhone: '',
        inquiryCreatedLink: '',
        inquiryCreatedList: '',
        inquiryFootnote: '',
        inquiryHistory: '',
        inquirySend: '',
        notRequired: '',
        notSelected: '',
        phone: '',
        phonePlaceholder: '',
        phoneTooltip: '',
        requiredField: '',
        themePlaceholder: '',
        topic: '',
        filesExceededError: '',
    },
    form: {
        attachFile: '',
        attachedFiles: '',
        cancel: '',
        requiredField: '',
        save: '',
        maxFilesLength: '',
        maxLengthFilesErrorModal: {
            title: '',
            title_one: '',
            title_few: '',
        },
        validation: {
            'field.email': '',
            'field.notType': '',
            'field.number.max': '',
            'field.number.min': '',
            'field.number.positive': '',
            'field.number.nonnegative': '',
            'field.number.integer': '',
            'field.number.notnumber': '',
            'field.email.format': '',
            'field.title.long': '',
            'field.name.long': '',
            'field.link.long': '',
            'field.template.name.long': '',
            'field.phone.format': '',
            'field.phone.common.format': '',
            'field.required': '',
            'field.link.incorrect': '',
            'file.corrupted': '',
            'file.data.empty': '',
            'file.exist': '',
            'file.format.incorrect': '',
            'file.not.found': '',
            'file.rows.exceeded': '',
            'file.size.exceeded': '',
            'files.size.exceeded': '',
            'file.delete.failed': '',
            'files.name.too.long': '',
            'file.name.too.long': '',
            'file.upload.unavailable': '',
        },
    },
    labelEditor: {
        apply: '',
        btnCreate: '',
        btnImport: '',
        close: '',
        createLabel: '',
        createPlaceholder: '',
        noSearchMatcher: '',
        removeModal: {
            buttonCancel: '',
            buttonOk: '',
            text: '',
            title: '',
        },
        searchPlaceholder: '',
        selectAll: '',
        title: '',
    },
    modal: {
        accessibly: '',
        apply: '',
        attention: '',
        cancel: '',
        change: '',
        close: '',
        continue: '',
        error: '',
        errorMsg: {
            codes: {},
            defaultMessage: '',
        },
        formReport: '',
        good: '',
        ok: '',
        prepaymentInvoice: '',
        remove: '',
        save: '',
        send: '',
        summ: '',
        success: '',
    },
    modalOrder: {
        details: '',
        orderMessageEnd: '',
        orderMessageStart: '',
    },
    modalVersionUpdate: {
        btn: 'Обновить',
        text: 'Пожалуйста обновите страницу',
        title: 'Версия портала изменена',
    },
    noticePageId: {
        account: {
            defaultMessage: '',
            onVerificationMessage: '',
        },
        subscriber: {
            defaultMessage: '',
            onVerificationMessage: '',
        },
    },
    selector: {
        about: '',
        changeUser: '',
        exit: '',
        settings: '',
    },
    status: {
        codes: {},
        defaultMessage: '',
    },
    superSearch: {
        accounts: '',
        accountsCount: ['', '', ''],
        fixedLabels: '',
        fixes: '',
        found: '',
        mobileLabels: '',
        mobiles: '',
        mobilesCount: ['', '', ''],
        notFound: '',
        notLoad: '',
        repeat: '',
    },
    tabMenuCompactView: {
        account: '',
        main: '',
        cashback: '',
        history: '',
        inquiries: '',
        mobile: '',
        offers: '',
        orders: '',
        products: '',
        reports: '',
        subscribersMobile: '',
        collectiveProduct: '',
        news: '',
    },
    userTypes: initTranslationUserTypes,
    instructionsLinks: {
        subsGeneral: {},
        subsFilter: {},
        subsImportSubs: {},
        subsImportPers: {},
        subsImportPersDel: {},
        subsImportLimits: {},
        subsExport: {},
        repsAdd: {},
        accessMaster: {},
        persAccMaster: {},
        lcGeneral: {},
        lcExport: {},
        repsBasic: {},
        paymentsGeneral: {},
        paymentsExport: {},
        expensesGeneral: {},
        expensesExport: {},
        repCorpExpenses: {},
        inqCreateHelp: {},
        billsHowto: {},
        billsExport: {},
        inqsGeneral: {},
        inqsHowCreate: {},
        inqsForms: {},
        inqsExport: {},
        ordersGeneral: {},
        ordersExport: {},
    },
};

export default initTranslationCorporate;
